import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as ShowerIcon } from "../../assets/images/bath.svg";
import { ReactComponent as BedIcon } from "../../assets/images/bed.svg";
import { ReactComponent as AreaIcon } from "../../assets/images/sqreft.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/phone.svg";
import { ReactComponent as UserIcon } from "../../assets/images/user.svg";
import { ReactComponent as MailIcon } from "../../assets/images/mail.svg";
import { ReactComponent as LocIcon } from "../../assets/svg/loc-icon.svg";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import { useSelector, useDispatch } from "react-redux";
import { agentDashboardSelector } from "../../redux/agentDashboard";
import { GetAllPropertyBookedForVisitDataList, GetAllPropertyScheduledForVisitList } from "../../services/propertyScheduledForVisit";
import Loader from "../../components/loader/Loader";
import { useNavigate } from "react-router-dom";
import { getAgentTimeSlotsService, propertyScheduleRequestApproval } from "../../services/SchedulePropertyVisit";
import CustomInput from "../../components/CustomInput/CustomInput";
import moment from "moment";
import ConfirmationModal from "../../components/Dialog/ConfirmationModal";
import { formatMozambicanMetical } from "../../lib/helper";

const AgentDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [visitSlotList, setvisitSlotList] = useState([]);
  const [confirmOpenDialog, setConfirmOpenDialog] = useState(false);
  const [propertyItemListing, setPropertyItemListing] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState();
  const [loading, setLoading] = useState(false);

  const { propertyBookedForVisitList } = useSelector(agentDashboardSelector);
  const { propertyScheduledForVisitData } = useSelector(agentDashboardSelector);
  const getMyPropertyList = () => {
    dispatch(GetAllPropertyBookedForVisitDataList());
  };
  const getMyPropertyScheduledForVisitList = () => {
    dispatch(GetAllPropertyScheduledForVisitList());
  };

  const handleConfirmDelete = async (value) => {
    if (value && selectedRowData) {
      handleAcceptScheduleVisit(selectedRowData);
    } else {
      setSelectedRowData(null);
    }
  };

  const handleCofirmModalOpen = (value) => {
    setConfirmOpenDialog(value);
  };

  useEffect(() => {
    setLoading(true);
    if (propertyBookedForVisitList && propertyBookedForVisitList?.items?.data) {
      const tempNewValues = propertyBookedForVisitList?.items?.data
        ?.slice(0, 5)
        ?.map((data) => {
          const tempArr = [];
          if (data?.schedule_date && data?.timeslot) {
            const newTempObj = visitSlotList?.find(
              (timing) => Number(timing?.id) == Number(data?.timeslot)
            );
            tempArr.push({
              ...newTempObj,
              shcedule_date: data?.schedule_date,
              shcedule_date_rank: 1,
            });
          }
          if (data?.schedule_date_2 && data?.timeslot_2) {
            const newTempObj = visitSlotList?.find(
              (timing) => Number(timing?.id) == Number(data?.timeslot_2)
            );
            tempArr.push({
              ...newTempObj,
              shcedule_date: data?.schedule_date_2,
              shcedule_date_rank: 2,
            });
          }
          if (data?.schedule_date_3 && data?.timeslot_3) {
            const newTempObj = visitSlotList?.find(
              (timing) => Number(timing?.id) == Number(data?.timeslot_3)
            );
            tempArr.push({
              ...newTempObj,
              shcedule_date: data?.schedule_date_3,
              shcedule_date_rank: 3,
            });
          }
          return {
            ...data,
            timeSlots: tempArr,
            selectedSlot: {},
          };
        });
      setPropertyItemListing(tempNewValues);
    }
    setLoading(false);
  }, [visitSlotList, propertyBookedForVisitList]);
  useEffect(() => {
    getTimeSlotsList();
    getMyPropertyList();
    getMyPropertyScheduledForVisitList();
  }, []);
  const getTimeSlotsList = async () => {
    try {
      setLoading(true);
      let data = await getAgentTimeSlotsService();
      setvisitSlotList(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const handleChangeSelectedSlot = (e, indexOfData) => {
    const tempArr = [...propertyItemListing];
    const timeSlotsWithDate = String(e.target.value)?.split("-");
    const tempObj = {
      shcedule_date_rank: timeSlotsWithDate[0],
      id: timeSlotsWithDate[1],
    };
    tempArr[indexOfData].selectedSlot = tempObj;
    setPropertyItemListing(tempArr);
  };
  const handleAcceptScheduleVisit = async (rowData) => {
    const payload = {
      schedule_visit_id: Number(rowData?.id),
      timeslot_status: Number(rowData?.selectedSlot?.shcedule_date_rank),
      timeslot_id: Number(rowData?.selectedSlot?.id),
    };
    const resp = await propertyScheduleRequestApproval(payload);
    if (resp) {
      getMyPropertyList();
      getMyPropertyScheduledForVisitList();
    }
  };
  return (
    <>
      {(propertyBookedForVisitList?.loading || loading) && <Loader />}

      {/* Property Booked for Visit Section */}
      <Box
        component="section"
        sx={{
          background: "#FFFFFF",
          borderRadius: "24px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.04)",
          border: "1px solid #F1F5F9",
          overflow: "hidden",
          mt: 2,
          mb: 5,
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 4,
          borderBottom: "1px solid #F1F5F9",
          background: "linear-gradient(to right, #F8FAFC, #FFFFFF)"
        }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              color: "#0F172A",
              fontFamily: "Outfit, sans-serif"
            }}
          >
            {t("Agent_dashboard.Property booked for Visit")}
          </Typography>
          <Button
            variant="text"
            sx={{
              textTransform: 'none',
              fontSize: "0.9375rem",
              color: "#0085FD",
              fontWeight: 600,
              px: 2,
              borderRadius: '8px',
              "&:hover": {
                backgroundColor: "rgba(0, 133, 253, 0.04)",
              },
            }}
            onClick={() => navigate(`/book-visit`)}
          >
            {t("Agent_dashboard.View All")}
          </Button>
        </Box>
        <Box sx={{ p: 0 }}>
          <TableContainer sx={{
            boxShadow: 'none',
            '& svg': {
              width: '18px !important',
              height: '18px !important',
              '& path, & circle, & rect, & ellipse': {
                fill: '#0085FD !important'
              },
              '& [stroke]': {
                stroke: '#0085FD !important',
                fill: 'none !important'
              }
            }
          }}>
            <Table sx={{ minWidth: 1023 }} aria-label="property table">
              <TableHead sx={{ bgcolor: "#F8FAFC" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Property")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Name")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Location")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Details")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Select Slot")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Price")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, textAlign: 'center', pr: 4 }}>{t("Agent_dashboard.Action")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertyItemListing && propertyItemListing.length > 0 ? (
                  propertyItemListing?.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: "pointer",
                        transition: 'all 0.2s',
                        "&:hover": { bgcolor: "rgba(248, 250, 252, 0.8)" },
                        "&:last-child td, &:last-child th": { border: 0 }
                      }}
                    >
                      <TableCell
                        sx={{ width: 120, py: 3, pl: 4 }}
                        onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}>
                        <img
                          src={row?.image_url ? row?.image_url : "../../assets/img/rectangle.png"}
                          style={{
                            width: '100px',
                            height: '75px',
                            objectFit: 'cover',
                            borderRadius: '12px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                          }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ py: 3 }}
                        onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                      >
                        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1E293B', mb: 0.5 }}>
                          {row?.property_title}
                        </Typography>
                        <Typography sx={{ fontSize: '0.8125rem', color: '#64748B', mb: 1.5, fontWeight: 500 }}>
                          {row?.property_category_title}
                        </Typography>
                        <Box
                          sx={{
                            display: 'inline-block',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: '6px',
                            bgcolor: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "rgba(68, 125, 239, 0.1)" : "rgba(100, 116, 139, 0.1)",
                            color: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "#447DEF" : "#64748B",
                            fontSize: '0.6875rem',
                            fontWeight: 800,
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                          }}
                        >
                          {(row?.property_type_master_id == 2 ||
                            row?.property_type_master_id == 5) ? "For Sale" : (row?.property_type_master_id == 3 || row?.property_type_master_id == 6)
                            ? "For Rent" : (row?.property_type_master_id == 4) ? "For Share" : ""}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{ color: "#475569", fontSize: "0.875rem", lineHeight: "1.6", py: 3 }}
                        onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                          <LocIcon style={{ marginTop: '2px' }} />
                          <Box component="span" sx={{ fontWeight: 500 }}>
                            {row?.address_1}, {row?.address_2} <br />
                            <Box component="span" sx={{ color: '#94A3B8' }}>{row?.city}, {row?.state}</Box>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{ color: "#475569", fontSize: "0.875rem", py: 3 }}
                        onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                            <AreaIcon /> {row?.total_property_area}
                          </Box>
                          {row?.no_of_bedrooms > 0 &&
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                              <BedIcon /> {row?.no_of_bedrooms}
                            </Box>
                          }
                        </Box>
                      </TableCell>
                      <TableCell sx={{ py: 3 }}>
                        <Box sx={{ minWidth: 170 }}>
                          <CustomInput
                            variant="outlined"
                            fullWidth
                            select
                            SelectProps={{ native: true }}
                            placeholder={t("Agent_dashboard.Select Slot")}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleChangeSelectedSlot(e, index)}
                            value={`${Number(row?.selectedSlot?.shcedule_date_rank)}-${Number(row?.selectedSlot?.id)}`}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                fontSize: '0.8125rem',
                                bgcolor: '#F8FAFC',
                                border: '1px solid #E2E8F0',
                                '&:hover': { bgcolor: '#F1F5F9' },
                                '& fieldset': { border: 'none' }
                              }
                            }}
                          >
                            <option value="">{t("Agent_dashboard.Select Time Slots")}</option>
                            {row?.timeSlots &&
                              row?.timeSlots?.map((times, subIndex) => (
                                <option
                                  key={subIndex}
                                  value={`${times?.shcedule_date_rank}-${times?.id}`}
                                >
                                  {`${moment(times?.shcedule_date)?.format("DD-MM-YYYY")} (${times?.slot_from} - ${times?.slot_to})`}
                                </option>
                              ))}
                          </CustomInput>
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{ py: 3 }}
                        onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                      >
                        <Typography sx={{ color: "#0085FD", fontWeight: 800, fontSize: "1.125rem", fontFamily: 'Outfit' }}>
                          {formatMozambicanMetical(row?.offered_price)}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ py: 3, pr: 4 }}>
                        <Button
                          variant="contained"
                          disableElevation
                          fullWidth
                          onClick={() => {
                            handleCofirmModalOpen(true);
                            setSelectedRowData(row);
                          }}
                          disabled={!(row?.selectedSlot?.shcedule_date_rank && row?.selectedSlot?.id)}
                          sx={{
                            bgcolor: "#0085FD",
                            color: "#FFFFFF",
                            borderRadius: "10px",
                            textTransform: "none",
                            fontWeight: "700",
                            fontSize: "0.875rem",
                            py: 1.25,
                            "&:hover": { bgcolor: "#0072DB" },
                            "&.Mui-disabled": { bgcolor: "#F1F5F9", color: "#CBD5E1" }
                          }}
                        >
                          {t("Agent_dashboard.Accept")}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} sx={{ textAlign: 'center', py: 8, color: '#94A3B8', fontSize: '1rem', fontWeight: 500 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1">{t("Agent_dashboard.No property booked for visit")}</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Property Scheduled for Visit Section */}
      <Box
        component="section"
        sx={{
          background: "#FFFFFF",
          borderRadius: "24px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.04)",
          border: "1px solid #F1F5F9",
          overflow: "hidden",
          mb: 5,
        }}
      >
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 4,
          borderBottom: "1px solid #F1F5F9",
          background: "linear-gradient(to right, #F8FAFC, #FFFFFF)"
        }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              color: "#0F172A",
              fontFamily: "Outfit, sans-serif"
            }}
          >
            {t("Agent_dashboard.Property Scheduled for Visit")}
          </Typography>
          <Button
            variant="text"
            sx={{
              textTransform: 'none',
              fontSize: "0.9375rem",
              color: "#0085FD",
              fontWeight: 600,
              px: 2,
              borderRadius: '8px',
              "&:hover": {
                backgroundColor: "rgba(0, 133, 253, 0.04)",
              },
            }}
            onClick={() => navigate(`/scheduled-visit`)}
          >
            {t("Agent_dashboard.View All")}
          </Button>
        </Box>
        <Box sx={{ p: 0 }}>
          <TableContainer sx={{
            boxShadow: 'none',
            '& svg': {
              width: '18px !important',
              height: '18px !important',
              '& path, & circle, & rect, & ellipse': {
                fill: '#0085FD !important'
              },
              '& [stroke]': {
                stroke: '#0085FD !important',
                fill: 'none !important'
              }
            }
          }}>
            <Table sx={{ minWidth: 1003 }} aria-label="scheduled table">
              <TableHead sx={{ bgcolor: "#F8FAFC" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Property")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Name")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Price")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Location")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Details")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5 }}>{t("Agent_dashboard.Client Info")}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: "#64748B", py: 2.5, pr: 4 }}>{t("Agent_dashboard.Schedule")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {propertyScheduledForVisitData.items?.data && propertyScheduledForVisitData.items?.data.length > 0 ? (
                  propertyScheduledForVisitData.items?.data
                    .slice(0, 5)
                    .map((row, i) => {
                      const newTempObj = visitSlotList?.find(
                        (timing) => Number(timing?.id) == Number(row?.timeslot_id)
                      );
                      return (
                        <TableRow
                          key={i}
                          sx={{
                            cursor: "pointer",
                            transition: 'all 0.2s',
                            "&:hover": { bgcolor: "rgba(248, 250, 252, 0.8)" },
                            "&:last-child td, &:last-child th": { border: 0 },
                            opacity: row?.status == 3 ? 0.5 : 1,
                          }}
                          onClick={() => navigate(`/view-property-agent/${row?.property_id}`)}
                        >
                          <TableCell sx={{ width: 120, py: 3, pl: 4 }}>
                            <img
                              src={row?.image_url ? row?.image_url : "../../assets/img/rectangle.png"}
                              style={{
                                width: '100px',
                                height: '75px',
                                objectFit: 'cover',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                              }}
                            />
                          </TableCell>

                          <TableCell sx={{ py: 3 }}>
                            <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1E293B', mb: 0.5 }}>
                              {row?.property_title}
                            </Typography>
                            <Typography sx={{ fontSize: '0.8125rem', color: '#64748B', mb: 1.5, fontWeight: 500 }}>
                              {row?.property_category_title}
                            </Typography>
                            <Box
                              sx={{
                                display: 'inline-block',
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                bgcolor: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "rgba(68, 125, 239, 0.1)" : "rgba(100, 116, 139, 0.1)",
                                color: (row?.property_type_master_id == 2 || row?.property_type_master_id == 5) ? "#447DEF" : "#64748B",
                                fontSize: '0.6875rem',
                                fontWeight: 800,
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                              }}
                            >
                              {(row?.property_type_master_id == 2 ||
                                row?.property_type_master_id == 5) ? "For Sale" : (row?.property_type_master_id == 3 || row?.property_type_master_id == 6)
                                ? "For Rent" : (row?.property_type_master_id == 4) ? "For Share" : ""}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ py: 3 }}>
                            <Typography sx={{ color: "#0085FD", fontWeight: 800, fontSize: "1.125rem", fontFamily: 'Outfit' }}>
                              {formatMozambicanMetical(row?.offered_price)}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ color: "#475569", fontSize: "0.875rem", lineHeight: "1.6", py: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                              <LocIcon style={{ marginTop: '2px' }} />
                              <Box component="span" sx={{ fontWeight: 500 }}>
                                {row?.address_1}, {row?.address_2} <br />
                                <Box component="span" sx={{ color: '#94A3B8' }}>{row?.city}, {row?.state}</Box>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ color: "#475569", fontSize: "0.875rem", py: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                                <AreaIcon /> {row?.total_property_area}
                              </Box>
                              {row?.no_of_bedrooms > 0 &&
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 600 }}>
                                  <BedIcon /> {row?.no_of_bedrooms}
                                </Box>
                              }
                            </Box>
                          </TableCell>
                          <TableCell sx={{ py: 3 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#1E293B', fontWeight: 600, fontSize: '0.875rem' }}>
                                <UserIcon style={{ width: 16, marginRight: 8 }} /> {row?.first_name} {row?.last_name}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#64748B', fontSize: '0.8125rem' }}>
                                <MailIcon style={{ width: 16, marginRight: 8 }} /> {row?.email}
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', color: '#64748B', fontSize: '0.8125rem' }}>
                                <PhoneIcon style={{ width: 16, marginRight: 8 }} /> {row?.contact_number}
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell sx={{ py: 3, pr: 4 }}>
                            <Box sx={{
                              p: 1.5,
                              borderRadius: '12px',
                              bgcolor: 'rgba(0, 133, 253, 0.04)',
                              border: '1px solid rgba(0, 133, 253, 0.1)',
                              minWidth: 140
                            }}>
                              <Typography sx={{ color: '#0085FD', fontWeight: 700, fontSize: "0.875rem", mb: 0.5 }}>
                                {moment(
                                  Number(row?.timeslot_status) == 1
                                    ? row?.schedule_date
                                    : Number(row?.timeslot_status) == 2
                                      ? row?.schedule_date_2
                                      : row?.schedule_date_3
                                )?.format("DD MMM, YYYY")}
                              </Typography>
                              <Typography sx={{ color: '#64748B', fontSize: '0.75rem', fontWeight: 600 }}>
                                {`${newTempObj?.slot_from} - ${newTempObj?.slot_to}`}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} sx={{ textAlign: 'center', py: 8, color: '#94A3B8', fontSize: '1rem', fontWeight: 500 }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body1">{t("Agent_dashboard.No property scheduled for visit")}</Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {confirmOpenDialog && (
        <ConfirmationModal
          open={confirmOpenDialog}
          handleConfirm={handleConfirmDelete}
          setOpen={handleCofirmModalOpen}
        />
      )}
    </>
  );
};
export default AgentDashboard;
